import { feature as graphQLClientFeature } from '@central-products/graphql-client';

export const graphqlClientPlugin = {
  beforeBootstrap({ addBootstrapperFeature }) {
    addBootstrapperFeature(graphQLClientFeature);
  },
};
